import base from "../base.js";
import screenSize from "../definition/screenSize.js";

export default class Position extends base {
    objectType = "Position";
    _x = 0;
    _y = 0;
    _width = 0;
    _height = 0;
    _maxSizeX = screenSize.width;
    _maxSizeY = screenSize.height;
    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue({...args, canBeHide: false, show: false});
        this.maxSizeX = args.maxSizeX ? args.maxSizeX : screenSize.width;
        this.maxSizeY = args.maxSizeY ? args.maxSizeY : screenSize.height;
        if (args.size != null) {
            this.width = args.size.width !== undefined ? args.size.width : args.size.largeur !== undefined ? args.size.largeur : screenSize.width;
            this.height = args.size.height !== undefined ? args.size.height : args.size.hauteur !== undefined ? args.size.hauteur : screenSize.height;
        }
        else {
            this.width = args.largeur !== undefined ? args.largeur : args.width !== undefined ? args.width : screenSize.width;
            this.height = args.hauteur !== undefined ? args.hauteur : args.height !== undefined ? args.height : screenSize.height;
        }
        this.x = args.x !== undefined ? args.x : 0;
        this.y = args.y !== undefined ? args.y : 0;
        this.CanBeRemove = false;
        this.CanChangeName = false;
    }

    get maxSizeX() {
        return this._maxSizeX;
    }
    set maxSizeX(maxSizeX) {
        this._maxSizeX = Math.floor(maxSizeX);
        this.x = this.x;
        this.width = this.width;
        this.y = this.y;
        this.height = this.height;
    }

    get maxSizeY() {
        return this._maxSizeY;
    }
    set maxSizeY(maxSizeY) {
        this._maxSizeY = Math.floor(maxSizeY);
        this.x = this.x;
        this.width = this.width;
        this.y = this.y;
        this.height = this.height;
    }

    get x() {
        return this._x;
    }
    set x(x) {
        if (this.width + x > this.maxSizeX && this.maxSizeX != -1) {
            x = this.maxSizeX - this.width;
        }
        if (x < 0)
            x = 0;
        this._x = Math.floor(x);
    }
    get y() {
        return this._y;
    }
    set y(y) {
        if (this.height + y > this.maxSizeY && this.maxSizeY != -1) {
            y = this.maxSizeY - this.height;
        }
        if (y < 0)
            y = 0;
        this._y = Math.floor(y);
    }
    get width() {
        return this._width;
    }
    set width(width) {
        let x = 0;
        if (this.x != null) {
            x = this.x;
        }
        if (x + width > this.maxSizeX && this.maxSizeX != -1) {
            width = this.maxSizeX - x;
        }
        if (width <= 0)
            width = 1;
        this._width = Math.floor(width);
    }
    get height() {
        return this._height;
    }
    set height(height) {
        let y = 0;
        if (this.y != null) {
            y = this.y;
        }
        if (y + height > this.maxSizeY && this.maxSizeY != -1) {
            height = this.maxSizeY - y;
        }
        if (height <= 0)
            height = 1;
        this._height = Math.floor(height);
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            // { property: "Size", construct: sizeItem, jsType: "Class" },
            { property: "width", construct: Number, jsType: "Number" },
            { property: "height", construct: Number, jsType: "Number" },
            { property: "x", construct: Number, jsType: "Number" },
            { property: "y", construct: Number, jsType: "Number" },
        ];
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "width", text: "Largeur", type: "numberInput", dataType: "number" },
            { name: "height", text: "Hauteur", type: "numberInput", dataType: "number" },
            {name:"x", text: "X", type:"numberInput", dataType: "number"},
            {name:"y", text: "Y", type:"numberInput", dataType: "number"},
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    static get Name() {
        return "Taille - Position";
    }
    IsValid() {
        if (this.x < 0 || this.y < 0)
            return false;
        return true;
    }
    static FromSize(size = null) {
        if (size == null) {
            return new Position({x: 0, y: 0, width: 1024, height: 768});
        }
        return new Position({x: 0, y: 0, size: size});
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            x: parseInt(this.x),
            y: parseInt(this.y),
            size: {
                width: parseInt(this.width),
                height: parseInt(this.height),
            }
        }
    }
    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            x: this.x,
            y: this.y,
            size: {
                width: this.width,
                height: this.height,
            }
        }
    }
    getFromPreviewId(id) {
        if (super.hasPreviewId(id) == true)
            return this;
        if (this.Size != null) {
            return this.Size.getFromPreviewId(id);
        }
        return null;
    }
}
